"use client";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useContext, useState } from "react";
import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { CallToAction } from "../../atoms";
import { ArrowRight } from "../../icons";
import { useUIDSeed } from "react-uid";
import { ImageContext } from "../../../context";
import { twMerge } from "../../../utils";
export var Popover = function(param) {
    var title = param.title, text = param.text, callToActions = param.callToActions, image = param.image;
    var ref = _slicedToArray(useState(true), 2), show = ref[0], setShow = ref[1];
    var ctaSeed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        "aria-live": "assertive",
        className: "z-50 pointer-events-none fixed inset-0 flex items-end px-4 py-6 md:items-center md:p-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex w-full flex-col items-center space-y-4 md:items-end"
    }, /*#__PURE__*/ React.createElement(Transition, {
        show: show
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-1/6 md:h-auto flex md:block pointer-events-auto md:w-2/12 max-w-sm min-w-[190px] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "".concat(image ? "grid md:grid-cols-1 grid-cols-3" : "")
    }, !!image && /*#__PURE__*/ React.createElement("div", {
        className: "col-span-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-start md:max-w-none"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({
        className: "h-48 w-full md:h-auto md:w-auto object-cover"
    }, image)))), /*#__PURE__*/ React.createElement("div", {
        className: "grid items-center ".concat(image ? "col-span-2" : "")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "p-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-start"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "ml-3 w-auto flex-1 pt-0.5"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-sm font-medium text-gray-900"
    }, title), /*#__PURE__*/ React.createElement("p", {
        className: "mt-1 text-sm text-gray-500"
    }, text), /*#__PURE__*/ React.createElement("div", {
        className: "mt-3 flex space-x-7"
    }, !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex items-center flex-wrap -m-4 md:justify-end")
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: ctaSeed(action),
            subtle: true,
            className: "m-4",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, {
                className: "text-fg-inverted"
            }),
            linkVariant: "big"
        }));
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "ml-4 flex shrink-0"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: function() {
            setShow(false);
        },
        className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Close"), /*#__PURE__*/ React.createElement(XMarkIcon, {
        "aria-hidden": "true",
        className: "w-5 h-5"
    }))))))))))));
};

//# sourceMappingURL=Popover.js.map